/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("manuscriptDetailsRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("manuscriptdetails", {
        url: "/manuscriptdetails?id&type&platform",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="detailbody view_body">' +
                    '<div class="detailContent" ui-view="main"></div>' +
                    '</div>'
            },
            "header@manuscriptdetails": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@manuscriptdetails": {
                templateUrl: "./main/submissionManage/personalLibrary/manuscriptDetails/manuscriptDetails_tpl.html",
                controller: "manuscriptDetailsCtrl"
            }
        }
    });
}]);